import { alpha } from '@mui/material/styles';
import { colorPalette } from '../../colorPalette';
export const drawerBackdropStyle = {
    backgroundColor: alpha(colorPalette.gray1000, .3)
};
export const drawerPaperStyle = {
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    fontSize: '1.6rem',
    height: 'calc(100% - 16px)',
    display: 'flex',
    flexDirection: 'column'
};
export const drawerHeader = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px 32px 16px',
    borderBottom: `1px solid ${colorPalette.gray200}`
};
export const drawerHeaderIcon = {
    color: colorPalette.gray600,
    fontWeight: '200'
};
export const drawerHeaderTitle = {
    color: colorPalette.gray800,
    fontWeight: '600'
};
export const drawerFooter = {
    padding: '16px',
    borderTop: `1px solid ${colorPalette.gray200}`
};
export const radioDrawer = {
    color: colorPalette.gray900,
    '&.Mui-checked': {
        color: colorPalette.gray900,
    },
};
export const rowDrawer = {
    height: '32px',
    justifyContent: 'space-between',
    margin: 0,
    padding: '8px 12px 8px 16px',
    borderBottom: `1px solid ${colorPalette.gray200}`,
    '&:last-child': {
        border: 'none'
    }
};
